import AdminServerActionCreators from 'actions/AdminServerActionCreators';
import qs from 'qs';
import assign from 'object-assign';
import _ from 'underscore';
import client from './rest/AdminClient';
const orderQueryOptions = {
    select: 'meta severity modified_at created_at exception_type resolution order shipper reporter resolved release_time pending_release message type on_hold assignee',
    paginate: true,
    populate: [
        {
            path: 'order',
        },
        {
            path: 'shipper',
        },
        {
            path: 'assignee',
            select: '_id first_name last_name',
        },
    ],
    _type: 'order',
    per_page: 10,
    pending_release: false,
    resolved: false,
};
const queryOptions = {
    select: 'severity modified_at created_at exception_type resolution shipment shipper carrier stop reporter resolved release_time pending_release message type on_hold assignee',
    paginate: true,
    populate: [
        {
            path: 'shipment',
        },
        {
            path: 'stop',
        },
        {
            path: 'shipper',
        },
        {
            path: 'shipper.master_account',
        },
        {
            path: 'assignee',
            select: '_id first_name last_name',
        },
    ],
    _type: 'shipment',
    per_page: 11,
    pending_release: false,
    resolved: false,
};
const getOrderExceptions = (query) => {
    let q = query || {};
    const overrides = _.extend({}, orderQueryOptions, q, { page_size: 0 });
    const queryString = qs.stringify(overrides);
    return client({ method: 'GET', path: `/admin/api/v2/exceptions?${queryString}` });
};
const getExceptions = (query = {}) => {
    const q = Object.assign(Object.assign(Object.assign({}, queryOptions), { page_size: 0 }), query);
    const queryString = qs.stringify(q);
    return client({ method: 'GET', path: `/admin/api/v2/exceptions?${queryString}` });
};
const getShipperExceptions = (query) => {
    let q = query || {};
    const overrides = assign({}, queryOptions, { page_size: 0 });
    q = assign(q, overrides);
    const queryString = qs.stringify(q);
    return client({ method: 'GET', path: `/api/v2/exceptions?${queryString}` });
};
const addResolution = (exceptionId, type, message, meta) => {
    return client({
        method: 'POST',
        path: `/api/1/exceptions/${exceptionId}/resolve`,
        entity: JSON.stringify({
            type: type,
            resolution_message: message,
            meta,
        }),
    });
};
const bulkResolve = (exceptionIds) => {
    return client({
        method: 'POST',
        path: `/api/1/exceptions/resolve`,
        entity: JSON.stringify({
            exceptionIds,
        }),
    });
};
const updateException = (payload) => {
    return client({
        method: 'PATCH',
        path: '/admin/api/1/exceptions',
        entity: JSON.stringify(payload),
    });
};
export default {
    getOrderExceptions(query) {
        getOrderExceptions(query).then((res) => {
            const { exceptions, pages, meta } = res.entity;
            AdminServerActionCreators.receiveExceptions(exceptions, pages, meta);
        }, (err) => {
            console.error('failure to get exceptions', err);
        });
    },
    getExceptions(query) {
        getExceptions(query).then((res) => {
            const { exceptions, pages, meta } = res.entity;
            AdminServerActionCreators.receiveExceptions(exceptions, pages, meta);
        }, (err) => {
            console.error('failure to get exceptions', err);
        });
    },
    getShipperExceptions(query) {
        getShipperExceptions(query).then((res) => {
            AdminServerActionCreators.receiveExceptions(res.entity.exceptions, res.entity.pages);
        }, (err) => {
            console.error('failure to get exceptions', err);
        });
    },
    addResolution(exceptionId, type, message, meta) {
        addResolution(exceptionId, type, message, meta).then((res) => {
            AdminServerActionCreators.receiveException(res.entity.exception);
        }, (err) => {
            console.error('failure to add resolution', err);
        });
    },
    bulkResolve(exceptionIds) {
        bulkResolve(exceptionIds).then((res) => {
            AdminServerActionCreators.resolveExceptions(exceptionIds);
        }, (err) => {
            console.error('failure to bulk resolve', err);
        });
    },
    updateException(payload) {
        updateException(payload).then(res => AdminServerActionCreators.updateException(res.entity), err => AdminServerActionCreators.updateExceptionFail(err));
    },
};
